import * as z from "zod";
//#region src/__generated__/project-gge/projectSearchController/zod/projectSearchPatternSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchPatternSchema = z.object({
	pattern: z.enum([
		"CONTAINS",
		"RANGE",
		"EQUALS"
	]).optional().describe("Тип шаблона поиска."),
	value: z.array(z.string()).nullish().describe("Значение критерия поиска.")
}).describe("Критерии поиска, где ключи - названия полей, а значения - объекты ProjectSearchPattern. Возможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n'startDate' - дата начала проекта.\n");
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/projectSearchDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchDtoSchema = z.object({
	page: z.int().describe("Номер страницы для пагинации (нумерация начинается с 1)."),
	searchPatterns: z.object({}).catchall(projectSearchPatternSchema).optional().describe("Критерии поиска, где ключи - названия полей, а значения - объекты ProjectSearchPattern. Возможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n'startDate' - дата начала проекта.\n"),
	size: z.int().describe("Размер страницы (количество элементов на странице)."),
	sortBy: z.enum([
		"ID",
		"TITLE",
		"CREATED_AT",
		"ORGANIZATION",
		"MODIFIED_AT",
		"DELETED_AT",
		"IS_DELETED",
		"AUTHOR_ID",
		"TEMPLATE_ID",
		"DESCRIPTION",
		"START_DATE",
		"END_DATE",
		"LAT",
		"LON",
		"TOTAL_COST",
		"REALISATION_COST",
		"DOCUMENTATION_ID",
		"STAGE",
		"STATUS",
		"TYPE",
		"IS_ARCHIVED",
		"EXTERNAL_ID",
		"MAIN_TITLE"
	]).optional().describe("Поле, по которому будет выполнена сортировка."),
	sortDirection: z.enum(["ASC", "DESC"]).optional().describe("Направление сортировки: ASC (возрастание) или DESC (убывание).")
}).describe("Search object.");
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/projectMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectMetaDtoSchema = z.object({
	key: z.string(),
	value: z.string()
}).describe("Project metadata object.");
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/projectWithMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectWithMetaDtoSchema = z.object({
	authorId: z.uuid().nullish(),
	createdAt: z.iso.datetime().nullish(),
	description: z.string().nullish(),
	documentationId: z.uuid().nullish(),
	endDate: z.iso.datetime().nullish(),
	id: z.uuid().nullish(),
	isArchived: z.boolean(),
	isDeleted: z.boolean(),
	lat: z.number().nullish(),
	lon: z.number().nullish(),
	meta: z.array(projectMetaDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).nullish(),
	modifiedAt: z.iso.datetime().nullish(),
	objectName: z.string().nullish(),
	projectCostAtStart: z.number().nullish(),
	realisationCost: z.number().nullish(),
	stage: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional(),
	startDate: z.iso.datetime().nullish(),
	status: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional().describe("Dummy enum. Copy of 'stage' field for now."),
	templateId: z.uuid().nullish(),
	title: z.string().nullish(),
	totalCost: z.number().nullish(),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Объект проекта, в котором присутствует мета. Используется только при получении проектов пользователя для корректного отображения карточки проекта.");
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/projectSearchResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchResponseSchema = z.object({
	filteredProjects: z.int().describe("Количество проектов, соответствующих критериям поиска."),
	projectDto: z.array(projectWithMetaDtoSchema).describe("Список DTO проектов, соответствующих критериям поиска."),
	totalPage: z.int().describe("Общее количество страниц, соответствующих критериям поиска."),
	totalProjects: z.int().describe("Общее количество проектов.")
});
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/searchSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const searchQueryIsArchiveSchema = z.boolean().optional().describe("Указывает, следует ли включать архивные проекты.");
const searchStatus200Schema = projectSearchResponseSchema;
const searchResponseSchema = searchStatus200Schema;
const searchDataSchema = projectSearchDtoSchema.describe("Search object.");
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/projectFieldByProjectNameSearchDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectFieldByProjectNameSearchDtoSchema = z.object({
	field: z.enum([
		"ID",
		"TITLE",
		"CREATED_AT",
		"ORGANIZATION",
		"MODIFIED_AT",
		"DELETED_AT",
		"IS_DELETED",
		"AUTHOR_ID",
		"TEMPLATE_ID",
		"DESCRIPTION",
		"START_DATE",
		"END_DATE",
		"LAT",
		"LON",
		"TOTAL_COST",
		"REALISATION_COST",
		"DOCUMENTATION_ID",
		"STAGE",
		"STATUS",
		"TYPE",
		"IS_ARCHIVED",
		"EXTERNAL_ID",
		"MAIN_TITLE"
	]).describe("Поле, которое необходимо вернуть.\nВозможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n"),
	fieldMap: z.object({}).catchall(z.array(z.string())).optional().describe("Карта полей для фильтрации, где ключ - название поля, а значение - искомое значение."),
	mainSearchField: z.string().optional().describe("Поле для указания основного критерия поиска, если общий поиск выполняется по наименованию.")
});
//#endregion
//#region src/__generated__/project-gge/projectSearchController/zod/searchFieldsByProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const searchFieldsByProjectQueryIsArchiveSchema = z.boolean().optional();
const searchFieldsByProjectStatus200Schema = z.array(z.string());
const searchFieldsByProjectResponseSchema = searchFieldsByProjectStatus200Schema;
const searchFieldsByProjectDataSchema = projectFieldByProjectNameSearchDtoSchema;
//#endregion
export { projectFieldByProjectNameSearchDtoSchema as a, searchResponseSchema as c, projectWithMetaDtoSchema as d, projectMetaDtoSchema as f, searchFieldsByProjectStatus200Schema as i, searchStatus200Schema as l, projectSearchPatternSchema as m, searchFieldsByProjectQueryIsArchiveSchema as n, searchDataSchema as o, projectSearchDtoSchema as p, searchFieldsByProjectResponseSchema as r, searchQueryIsArchiveSchema as s, searchFieldsByProjectDataSchema as t, projectSearchResponseSchema as u };

//# sourceMappingURL=searchFieldsByProjectSchema.js.map